import { render, staticRenderFns } from "./OwnAnalytics.vue?vue&type=template&id=94e0abd8&"
import script from "./OwnAnalytics.vue?vue&type=script&lang=js&"
export * from "./OwnAnalytics.vue?vue&type=script&lang=js&"
import style0 from "./OwnAnalytics.vue?vue&type=style&index=0&id=94e0abd8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports